import { enableProdMode } from '@angular/core';
import {
  bootstrapApplication,
  provideClientHydration,
} from '@angular/platform-browser';
import { CMS_CONFIG, CmsConfig } from '@domgen/dgx-fe-cms';
import { mergeObject } from '@domgen/dgx-fe-common';
import { DOMAIN_CONFIG, RUNTIME_CONFIG } from '@domgen/dgx-fe-config';
import { provideApp } from './app/app.provider';
import { AppComponent } from './app/components/app.component';
import { AppDomainConfig } from './app/models/domain/app-domain-config.interface';
import { AppRuntimeConfig } from './app/models/runtime/app-runtime-config.interface';
import { environment } from './configs/environments/environment';

Promise.all([loadDomainConfig(), loadRuntimeConfig()])
  .then(([domainConfig, runtimeConfig]) => {
    if (environment.production) {
      enableProdMode();
    }

    const cmsConfig = mergeObject<CmsConfig>(
      environment.cms,
      runtimeConfig.cms
    );

    bootstrapApplication(AppComponent, {
      providers: [
        provideClientHydration(),
        {
          provide: CMS_CONFIG,
          useValue: cmsConfig,
        },
        {
          provide: DOMAIN_CONFIG,
          useValue: domainConfig,
        },
        {
          provide: RUNTIME_CONFIG,
          useValue: runtimeConfig,
        },
        provideApp(),
      ],
    }).catch((error) => console.error(error));
  })
  .catch((error) => {
    console.error(error);
  });

async function loadDomainConfig(): Promise<AppDomainConfig> {
  try {
    const url = `/configs/domains/domestic-and-general.json`;
    console.log(`Fetching domain config from: ${url}`);
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(
        `Failed to load domain config: ${response.status} ${response.statusText}`
      );
    }
    return response.json();
  } catch (error) {
    console.error('Error loading domain config:', error);
    throw error;
  }
}

async function loadRuntimeConfig(): Promise<AppRuntimeConfig> {
  try {
    const url = 'config.json';
    console.log(`Fetching runtime config from: ${url}`);
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(
        `Failed to load runtime config: ${response.status} ${response.statusText}`
      );
    }
    return response.json();
  } catch (error) {
    console.error('Error loading runtime config:', error);
    throw error;
  }
}
